import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import "./ImagePopup.scss";

function ImagePopup() {
    //const [show, setShow] = useState(false);
    const [show, setShow] = useState(false);
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    const popup = useSelector((state) => state.content.options.popup);

    function closePopup() {
        setShow(false);
    }

    useEffect(() => {
        setTimeout(() => {
            setShow(true);
        }, 2000);
    }, []);

    if (typeof popup != 'undefined' && show && popup.image && popup.active) {

        return (
            <div className="Image-Popup" onClick={() => closePopup()}>
                <div className='image-popup-interior' onClick={(e) => {e.stopPropagation();}}>
                    <div className='image-interior'>
                        <button class="close-button" onClick={() => closePopup()}>
                            <img src="/img-temp/close-btn.svg" />
                        </button>
                        <img className='popup-image' src={popup.image.url} />
                        {/* Links */}
                        {popup.links.map((link, li) => {
                            var linkstyles = {
                                top: link.position.top + "%",
                                left: link.position.left + "%",
                                width: link.position.width + "%",
                                height: link.position.height + "%",
                            };

                            return (
                                <a
                                    href={link.url}
                                    target='_blank'
                                    style={linkstyles}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div></div>
        );
    }
}

export default ImagePopup;